import * as types from './notifications.actionTypes';

export const fetchNotificationsRequestActionCreator = () => {
  return { type: types.FETCH_NOTIFICATIONS_REQUEST };
};

export const fetchNotificationsSuccessActionCreator = notifications => {
  return { type: types.FETCH_NOTIFICATIONS_SUCCESS, notifications };
};

export const fetchNotificationsFailureActionCreator = () => {
  return { type: types.FETCH_NOTIFICATIONS_FAILURE };
};

export const notificationRecievedActionCreator = notification => {
  return { type: types.NOTIFICATION_RECIEVED, notification };
};

export const markNotificationAsReadRequestActionCreator = () => {
  return { type: types.MARK_NOTIFICATION_AS_READ_REQUEST };
};

export const markNotificationAsReadSuccessActionCreator = notification => {
  return { type: types.MARK_NOTIFICATION_AS_READ_SUCCESS, notification };
};

export const markNotificationAsReadFailureActionCreator = () => {
  return { type: types.MARK_NOTIFICATION_AS_READ_FAILURE };
};

export const seeMoreNotificationsActionCreator = () => {
  return { type: types.SEE_MORE_NOTIFICATIONS };
};

export const resetUnreadCountActionCreator = () => {
  return { type: types.RESET_UNREAD_COUNT };
};

export const resetNotificationsActionCreator = () => {
  return { type: types.RESET_NOTIFICATIONS };
};
export const setChatUnreadCountActionCreator = count => {
  return { type: types.SET_CHAT_UNREAD_COUNT, count };
};
